import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule } from 'src/app/layouts/layout.module';
import { AuthGuard } from 'src/app/libs/guards/auth.guard';
import { BaseLayoutComponent } from './layouts/base/base-layout.component';
import { AppRedirectionGuard } from './libs/guards/app-redirection.guard';
import { EmptyPage } from './pages/empty-page';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    component: BaseLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/home/home.module').then((mod) => mod.HomeModule),
  },
  {
    path: 'pds',
    component: BaseLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pds/pds.module').then((m) => m.PdsModule),
  },
  { path: 'auth', loadChildren: () => import('./pages/auth/auth.module').then((mod) => mod.AuthModule) },
  {
    path: 'pdsshare',
    loadChildren: () => import('./pages/pds/pds.module').then((mod) => mod.PdsModule),
  },
  { path: 'app/:type/:shortenedToken', canActivate: [AppRedirectionGuard], component: EmptyPage },
  { path: 'app/:shortenedToken', canActivate: [AppRedirectionGuard], component: EmptyPage },
  {
    path: '',
    component: BaseLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'pds', loadChildren: () => import('./pages/pds/pds.module').then((m) => m.PdsModule) },
      {
        path: 'user-management',
        loadChildren: () =>
          import('src/app/pages/user-management/user-management.module').then((m) => m.UserManagementModule),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('src/app/pages/notifications/notification.module').then((m) => m.NotificationsModule),
      },
      {
        path: 'log-service',
        loadChildren: () => import('src/app/pages/log-service/log-service.module').then((m) => m.LogServiceModule),
      },
      {
        path: 'utilization',
        loadChildren: () => import('src/app/pages/utilization-monitoring/utilization-monitoring.module').then((m) => m.UtilizationMonitoringModule),
      },
      { path: '**', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  declarations: [BaseLayoutComponent],
  imports: [CommonModule, LayoutModule, RouterModule.forRoot(routes, { useHash: true })],
  providers: [AuthGuard],
  exports: [RouterModule],
})
export class AppRoutingModule {}
